export default __webpack_public_path__ + "de0a58c5d8ac2e62b0fad6456e6be7a9.png";